import { FC, PropsWithChildren } from 'react';
import { Layout } from '@repo/atomic-components';

export const LoginTemplate: FC<PropsWithChildren> = ({ children }) => {
  return (
    <Layout>
      <div className="grid h-full w-full grid-cols-[1fr] grid-rows-[1fr] gap-0">
        <div className="order-0 col-span-full flex flex-col items-center justify-center">{children}</div>
      </div>
    </Layout>
  );
};
